// src/pages/Coach/SubscriptionSuccess.jsx
import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2, ArrowRight, CreditCard } from "lucide-react";

export default function SubscriptionSuccess() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const sessionId = searchParams.get("session_id");

  // Optionally you could call your API here with sessionId to refresh coach data
  useEffect(() => {
    // Example (ONLY if you add such endpoint in backend):
    // if (sessionId) {
    //   fetch(`${API_BASE}/api/Billing/subscription/success?sessionId=${sessionId}`, { credentials: "include" })
    //     .then(() => console.log("Subscription confirmed"))
    //     .catch(() => console.log("Optional confirm failed"));
    // }
  }, [sessionId]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-blue-50 px-4">
      <div className="max-w-lg w-full bg-white rounded-3xl shadow-xl border border-blue-100 p-6 sm:p-8 text-center">
        <div className="flex justify-center">
          <div className="h-14 w-14 rounded-full bg-emerald-50 flex items-center justify-center mb-4">
            <CheckCircle2 className="h-8 w-8 text-emerald-600" />
          </div>
        </div>

        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900">
          Subscription activated 🎉
        </h1>

        <p className="mt-3 text-sm sm:text-base text-slate-600">
          Thank you! Your PTfinderNow subscription has been confirmed
          successfully via Stripe.
        </p>

        {sessionId && (
          <p className="mt-2 text-[11px] text-slate-400">
            Stripe session ID: <span className="font-mono">{sessionId}</span>
          </p>
        )}

        <div className="mt-6 rounded-2xl bg-blue-50 border border-blue-100 px-4 py-3 text-left text-xs sm:text-sm text-slate-700">
          <div className="flex items-start gap-2">
            <CreditCard className="h-4 w-4 mt-0.5 text-blue-500" />
            <div>
              <p className="font-semibold text-slate-900">
                What happens next?
              </p>
              <ul className="mt-1 list-disc list-inside space-y-1">
                <li>Your profile will be marked as subscribed.</li>
                <li>
                  You can read and reply to client inquiries while paid access is active.
                </li>
                <li>
                  You’ll receive an email receipt from Stripe / PTfinderNow.
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate("/dashboard")}
            className="inline-flex items-center justify-center rounded-xl bg-blue-600 px-5 py-2.5 text-sm font-semibold text-white hover:bg-blue-500 transition"
          >
            Go to dashboard
            <ArrowRight className="h-4 w-4 ml-2" />
          </button>

          <button
            onClick={() => navigate("/dashboard/subscription")}
            className="inline-flex items-center justify-center rounded-xl border border-slate-300 px-5 py-2.5 text-sm font-semibold text-slate-700 bg-white hover:bg-slate-50 transition"
          >
            Manage subscription
          </button>
        </div>

        <p className="mt-4 text-[11px] text-slate-400">
          If you don’t see your plan updated, refresh the page or log out and
          log in again.
        </p>
      </div>
    </div>
  );
}
